<ipo-borderless-button
  [icon]="'externalLink'"
  (clicked)="openFolder(ifsNumber)"
  [disabled]="isButtonDisabled()"
  data-test-id="ipo-borderless-button"
  class="sharepoint-container"
>
  Sharepoint
</ipo-borderless-button>
